module.exports = __webpack_public_path__ + "img/5.acea64dd.png";